module.exports = __webpack_public_path__ + "628b008cf54708720762393306dd2429.svg";